var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"9","height":"11","viewBox":"0 0 9 11","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M0.658 9.012V7.472L5.236 0.92H7.518V7.304H8.75V9.012H7.518V11H5.558V9.012H0.658ZM5.684 3.02L2.814 7.304H5.684V3.02Z","fill":"currentColor"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }